import React from 'react';
import { browserHistory } from 'react-router'

import request from 'services/request';
import Header from 'grommet/components/Header';
import Footer from 'grommet/components/Footer';
import Heading from 'grommet/components/Heading';
import Title from 'grommet/components/Title';
import Section from 'grommet/components/Section';
import Anchor from 'grommet/components/Anchor';
import Button from 'grommet/components/Button';
import Box from 'grommet/components/Box';
import Layer from 'grommet/components/Layer';
import Form from 'grommet/components/Form';
import FormField from 'grommet/components/FormField';
import List from 'grommet/components/List';
import ListItem from 'grommet/components/ListItem';
import Menu from 'grommet/components/Menu';

import Trash from 'grommet/components/icons/base/Trash';
import Add from 'grommet/components/icons/base/Add';
import Download from 'grommet/components/icons/base/Download';

import { isEmail } from 'utils/validation';

import TextInput from 'elements/TextInput';

export default class Admin extends React.Component {
  constructor() {
    super();
    this.addEmail = this.addEmail.bind(this);
    this.logOut = this.logOut.bind(this);
    this.refresh = this.refresh.bind(this);
    this.createSubscriber = this.createSubscriber.bind(this);
    this.openProfile = this.openProfile.bind(this);
    this.updateProfile = this.updateProfile.bind(this);

    this.state = {
      subscribers: [],
      fieldCount: 0,
      errors: {},
      user: {},
    };
  }

  componentWillMount() {
    this.refresh();
  }

  refresh() {
    request({
      method: 'GET',
      url: 'api/admin',
    }).then((res) => this.setState({ ...res.body }));
  }

  addEmail() {
    this.setState({
      showLayer: true,
      email: '',
     });
  }

  openProfile() {
    this.setState({
      showUserProfile: true,
    })
  }

  updateProfile(e) {
    e.preventDefault();
    if (!isEmail(this.state.user.email)) {
      return this.setState({ errors: { email: 'Invalid email address' } });
    }
    request({
      method: 'PATCH',
      url: 'api/admin/user',
      body: {
        email: this.state.user.email,
      }
    })
      .then(this.refresh)
      .then(() => this.setState({ showUserProfile: false, errors: {} }));
  }
  createSubscriber(e) {
    e.preventDefault();

    if (!isEmail(this.state.email)) {
      return this.setState({ errors: { email: 'Invalid email address' } });
    }

    request({
      method: 'POST',
      url: 'api/admin/subscriber',
      body: {
        email: this.state.email,
      }
    })
      .then(this.refresh)
      .then(() => this.setState({ showLayer: false, errors: {} }));
  }

  removeSubscriber(email) {
    request({
      method: 'DELETE',
      url: 'api/admin/subscriber',
      body: {
        email,
      }
    }).then(this.refresh);
  }

  logOut() {
    localStorage.removeItem('token');
    browserHistory.push('/login');
  }

  render() {
    const domain = process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : '';
    return (
      <div>
        <Header
          justify="between"
          size="small"
          colorIndex="brand"
          pad={{horizontal: 'small'}}>
          <Title>MRTN Survey</Title>
          <Menu label="My Account" dropAlign={{ right: 'right'}}>
            <Anchor onClick={this.openProfile} label="Change email address" />
            <Anchor onClick={this.logOut} label="Log out" />
          </Menu>
        </Header>
        <Section pad="medium" align="center">
          <Box size="medium" pad={{between: 'small'}}>
            <Box>
              <Header
                justify="between"
                size="small"
                pad="none">
                <Heading tag="h4" margin="none">
                  <strong>{this.state.fieldCount}</strong> field(s) have been submitted
                </Heading>
              </Header>
              <Box pad={{vertical: 'medium'}}>
                <Button href={`${domain}/api/admin/download?token=${localStorage.getItem('token')}`} icon={<Download />} label="Download data" primary/>
              </Box>
            </Box>
            <Box>
              <Header
                separator="bottom"
                justify="between"
                size="small"
                pad="none">
                <Heading tag="h4" margin="none">Who should receive notifications?</Heading>
                <Button icon={<Add />} onClick={this.addEmail} />
              </Header>
              <List>
                {this.state.subscribers.map(s =>
                  <ListItem pad="none"key={s} justify="between">
                    {s}
                    <Button icon={<Trash />} onClick={() => this.removeSubscriber(s)} />
                  </ListItem>
                )}
              </List>
            </Box>
          </Box>
        </Section>
        {this.state.showLayer &&
          <Layer
            align="right"
            closer
            onClose={() => this.setState({showLayer: false, errors: {} })}>
            <Box full="vertical" justify="center">
              <Form compact onSubmit={this.createSubscriber}>
                <Heading strong tag="h3">Add subscriber</Heading>
                <p>The email address you enter will receive a notification each time the entry form is submitted.</p>
                <FormField label="Email address" error={this.state.errors.email}>
                  <TextInput
                    value={this.state.email}
                    type="email"
                    onChange={(e) => this.setState({ email: e.target.value })} />
                </FormField>
                <Footer pad={{vertical: 'small'}}>
                  <Button onClick={this.createSubscriber} type="submit" label="OK" primary/>
                </Footer>
              </Form>
            </Box>
          </Layer>
        }
        {this.state.showUserProfile &&
          <Layer
            align="right"
            closer
            onClose={() => this.setState({showUserProfile: false, errors: {} })}>
            <Box full="vertical" justify="center">
              <Form compact onSubmit={this.updateProfile}>
                <FormField label="Email address" error={this.state.errors.email}>
                  <TextInput
                    value={this.state.user.email}
                    type="email"
                    onChange={(e) => this.setState({ user: {...this.state.user, email: e.target.value } })} />
                </FormField>
                <Footer pad={{vertical: 'small'}}>
                  <Button onClick={this.updateProfile} type="submit" label="OK" primary/>
                </Footer>
              </Form>
            </Box>
          </Layer>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Admin.js